"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _EmailFill = _interopRequireDefault(require("@rsuite/icon-font/lib/file/EmailFill"));

// Generated by script, don't edit it please.
var EmailFill = (0, _createSvgIcon["default"])({
  as: _EmailFill["default"],
  ariaLabel: 'email fill',
  category: 'file',
  displayName: 'EmailFill'
});
var _default = EmailFill;
exports["default"] = _default;
module.exports = exports.default;